import {
  experimentAssignmentsCookieName,
  experimentSubjectCookieName,
} from '../constants/experimentCookies';

export type StoredExperimentAssignment = {
  version: number;
  variant: string;
  assignedAt: string;
};

export type ExperimentCookies = {
  browserKey: string | null;
  assignments: Record<string, StoredExperimentAssignment>;
};

export default function parseExperimentCookies(
  cookieHeader: string | undefined
): ExperimentCookies {
  const cookies = Object.fromEntries(
    (cookieHeader ?? '')
      .split(';')
      .map((pair) => pair.trim().split('='))
      .filter(([name]) => name)
      .map(([name, ...value]) => [name, decodeURIComponent(value.join('='))])
  );

  return {
    browserKey: cookies[experimentSubjectCookieName] ?? null,
    assignments: parseAssignments(cookies[experimentAssignmentsCookieName]),
  };
}

function parseAssignments(
  value: string | undefined
): Record<string, StoredExperimentAssignment> {
  try {
    const parsed = value ? JSON.parse(value) : {};

    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (_) {
    return {};
  }
}
